import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Logo } from '../components/ui/Logo';
export function Splash() {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/welcome');
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <div className="w-full h-full bg-black flex flex-col items-center justify-center relative overflow-hidden" data-id="element-673">
      {/* Background decoration */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/10 rounded-full blur-3xl" data-id="element-674" />
      <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-neonOrange/10 rounded-full blur-3xl" data-id="element-675" />

      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.5,
      type: 'spring',
      bounce: 0.5
    }} className="flex flex-col items-center z-10" data-id="element-676">
        <motion.div animate={{
        y: [0, -8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2.5,
        ease: 'easeInOut'
      }} className="mb-4" data-id="element-677">
          <Logo className="w-64 h-auto" data-id="element-678" />
        </motion.div>

        <p className="text-softGray font-medium" data-id="element-679">Where the jokes never stop.</p>
      </motion.div>

      <motion.div className="absolute bottom-20 flex gap-2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.8
    }} data-id="element-680">
        {[0, 1, 2].map(i => <motion.div key={i} className="w-3 h-3 bg-primary rounded-full" animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 0.6,
        repeat: Infinity,
        delay: i * 0.15,
        ease: 'easeInOut'
      }} data-id="element-681" />)}
      </motion.div>
    </div>;
}